interface ProcessResult {
  hash: string;
  data: string;
  difficulty: number;
}

export function process(data: string, difficulty = 5): Promise<ProcessResult> {
  return new Promise<ProcessResult>((resolve, reject) => {
    const webWorkerURL = URL.createObjectURL(
      new Blob(['(', processTask(), ')()'], { type: 'application/javascript' }),
    );

    const worker = new Worker(webWorkerURL);

    worker.onmessage = (event: MessageEvent<ProcessResult>) => {
      worker.terminate();
      resolve(event.data);
    };

    worker.onerror = () => {
      worker.terminate();
      reject();
    };

    worker.postMessage({
      data,
      difficulty,
    });

    // Destroy URL Object
    URL.revokeObjectURL(webWorkerURL);
  });
}

function processTask() {
  return (() => {
    function digest(text: string): Promise<string> {
      return new Promise<string>((resolve, reject) => {
        const buffer = new TextEncoder().encode(text);

        crypto.subtle.digest('SHA-384', buffer).then((result) => {
          resolve(
            Array.from(new Uint8Array(result))
              .map((c) => c.toString(16).padStart(2, '0'))
              .join(''),
          );
        }, reject);
      });
    }

    addEventListener('message', async (event) => {
      const data = event.data.data;
      const difficulty = event.data.difficulty;

      let hash: string;
      let nonce = 0;
      do {
        hash = await digest(data + nonce++);
      } while (hash.substr(0, difficulty) !== Array(difficulty + 1).join('0'));

      postMessage({
        hash,
        data,
        difficulty,
      });
    });
  }).toString();
}
